import styled from "styled-components";

export const Container = styled.header`
    background-color: transparent;
    height: 65px;
    flex-grow: 1;
    padding: 2rem 1rem;
    width: 100%;

    > img 
    {
        cursor: pointer;
    }
`;


export const ToggleSwitchTheme = styled.label`
    position: absolute;
    display: inline-block;
    width: 60px;
    right: 2rem;
    height: 34px;
    z-index: 2;

    > input 
    {
        opacity: 0;
        width: 0;
        height: 0;
    }

    > .slider 
    {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;

        &::before
        {
            position: absolute;
            content: "";
            height: 26px;
            width: 26px;
            left: 4px;
            bottom: 4px;
            background-color: white;
            -webkit-transition: .4s;
            transition: .4s;
        }
    }

    > input:checked + .slider 
    {
        background-color: var(--dark-border-color);
    }

    > input:focus + .slider 
    {
        box-shadow: 0 0 1px #2196F3;
    }

    > input:checked + .slider:before 
    {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    .slider.round 
    {
        border-radius: 34px;
    }

    .slider.round:before 
    {
        border-radius: 50%;
    }
`;